
import { MapLocation } from '@/types/location';
import { buildingMountedScreens } from './buildingMountedScreens';
import { digitalBridgeScreens } from './digitalBridgeScreens';
import { ledScreens } from './ledScreens';
import { digitalSuperMegaScreens } from './digitalSuperMegaScreens';
import { digitalMegacomScreens } from './digitalMegacomScreens';

export const attentionOutdoorLocations: MapLocation[] = [
  ...buildingMountedScreens,
  ...digitalBridgeScreens,
  ...ledScreens,
  ...digitalSuperMegaScreens,
  ...digitalMegacomScreens
];

console.log('attentionOutdoorLocations exported:', attentionOutdoorLocations);
